import { NotificationListenerLocal } from "@/components/global/notification-listener/local";
import { NotificationListenerPush } from "@/components/global/notification-listener/push";

export function NotificationListener() {
  return (
    <>
      <NotificationListenerLocal />
      <NotificationListenerPush />
      {/* <NotificationListenerMessages /> */}
    </>
  );
}
